<template>
  <ul class="pro-flex-list">
    <li
      class="pro"
      v-for="(item,index) in handleData"
      :key="index"
      :class="item.cover_img?'active'+' '+row:'not'+' '+row"
    >
      <template v-if="item.cover_img">
        <router-link :to="{name:'auction',params: {goodsId:item.id}}">
          <div class="pro-img">
            <img v-lazy="item.cover_img" alt :key="item.cover_img">
          </div>
          <div class="title">{{item.name}}</div>
          <div class="price">当前价:￥{{item.current_auction_price}}元</div>
        </router-link>
      </template>
    </li>
  </ul>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "ProductRowFive",
  components: {},
  props: {
    row: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    handleData() {
      let data = this.list;
      data.forEach(() => {
        let list = data.length;
        let num = list % 5;
        if (num !== 0) {
          for (let i = 0; i < 5 - num; i++) {
            data.push({});
          }
        }
      });
      return this.list;
    }
  },
  methods: {
    ...mapActions(["getCartNumsAction"]),
    //切换收藏
    changeFav(id) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    addToCart(id) {
      let data = {
        product_id: id,
        nums: 1
      };
      this.$api.addCart(data).then(res => {
        if (res.status) {
          this.$notify({
            title: "加入购物车成功",
            type: "success",
            offset: 100,
            duration:2500,
            dangerouslyUseHTMLString: true,
            message: `<a href="/web/cart" style="background:#FF7159;color:#FFF;font-size:12px;padding:5px 22px;">去结算</a>`
          });
          this.getCartNums();
        }
      });
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  .pro {
    position: relative;
    // width: 234px;
    width: 19%;
    height: 330px;
    margin-bottom: 14px;
    padding: 5px;
    background: #fff;
    transition: all 0.25s linear;
    box-sizing: border-box;
    &.row-4 {
      width: 24%;
    }
    &.not {
      &.not {
        background: $theme-bg;
      }
    }
    &.active:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .pro-handle-icon {
        display: block;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      .pro-img {
        width: 220px;
        height: 220px;
        margin: 0 auto 10px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title {
        margin: 0 10px;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        font-weight: 400;
        color:#666;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
      }
      .desc {
        margin: 0 10px 10px;
        height: 18px;
        font-size: 12px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #b0b0b0;
      }
      .price {
        text-align: center;
        color: $price;
      }
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  display: none;
  position: absolute;
  height: 24px;
  top: 14px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    left: 10px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}
</style>